import * as React from 'react';
import { ICAccordionItem } from 'model/contentful/accordion';
import { IAccordionItem } from 'components/Accordion/Accordion';
import renderRichText from 'utils/contentful/renderRichText';

export const formatAccordionItems = (items?: ICAccordionItem[]): Array<IAccordionItem> => {
  if (!items?.length) return [];

  return items.map(item => ({
    title: item.title,
    children: renderRichText(item.content?.json)
  }));
};
